// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currentSessionCardContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid var(--blue-b0);
  border-radius: 8px;
  padding: 12px 10px 12px 10px;
  width: 100%;
  background-color: #fff;
}

.sessionCardHeading {
  display: flex;
  justify-content: space-between;
}

.sessionCardvalue {
  font-weight: 700;
  font-size: 1.5rem;
  margin-top: 8px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/Closing/components/CurrentSessionCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".currentSessionCardContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid var(--blue-b0);\n  border-radius: 8px;\n  padding: 12px 10px 12px 10px;\n  width: 100%;\n  background-color: #fff;\n}\n\n.sessionCardHeading {\n  display: flex;\n  justify-content: space-between;\n}\n\n.sessionCardvalue {\n  font-weight: 700;\n  font-size: 1.5rem;\n  margin-top: 8px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
